module.exports = __webpack_public_path__ + "img/avatar1.6b1c6691.png";